import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { HeaderSearchProps, SearchBarProps } from './Header.types';

const defaultHeaderSearchProps = {
  baseUrl: 'https://tfl.gov.uk',
  searchPath: 'search',
  queryParameterName: 'q',
} as HeaderSearchProps;

const Search = ({
  isMenuShown,
  isSubMenuShown,
  isSmallScreen,
  searchProps = defaultHeaderSearchProps,
}: SearchBarProps) => {
  const [searchValue, setSearchValue] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const { baseUrl, searchPath, queryParameterName } = searchProps;
  const searchInputRef = useRef(null);

  // Setting hidden elements to a tab value of -1.
  let tabValue = undefined;
  if ((!isMenuShown && isSmallScreen) || isSubMenuShown) {
    tabValue = -1;
  } else if (isMenuShown && !isSmallScreen) {
    tabValue = -1;
  }

  const clearSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setSearchValue('');
    searchInputRef.current.focus();
  };

  const cancelSearch = () => setSearchValue('');

  const storeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  const setFocus = () => {
    setIsSearchFocused(!isSearchFocused);
  };

  const keyHandleOnSubmit = (e: { key: string }) => {
    if (searchValue && e.key === 'Enter') {
      window.open(
        `${baseUrl}/${searchPath}/?${queryParameterName}=${searchValue}`,
        '_top'
      );
    }
  };

  return (
    <div
      className={classnames([
        'tfl-header__search',
        `tfl-header__search--${
          isSearchFocused || searchValue ? 'focused' : 'unfocused'
        }`,
      ])}
    >
      <label className="tfl-header__search-label" htmlFor="search">
        Search
      </label>
      <input
        tabIndex={tabValue}
        type="search"
        placeholder="Search"
        className={classnames([
          'tfl-header__search-input',
          `tfl-header__search-input--${
            isSearchFocused || searchValue ? 'focused' : 'unfocused'
          }`,
        ])}
        name="q"
        id="search"
        onChange={storeSearch}
        onFocus={setFocus}
        onBlur={setFocus}
        onKeyDown={keyHandleOnSubmit}
        value={searchValue || ''}
        autoComplete="off"
        ref={searchInputRef}
      />
      {!isSubMenuShown && searchValue && (
        <button
          tabIndex={tabValue}
          onClick={clearSearch}
          className="tfl-header__clear-search"
          aria-label="clear search"
        >
          <span className="visibility-hidden">Clear search</span>
        </button>
      )}
      <button
        tabIndex={searchValue ? 0 : -1}
        onClick={cancelSearch}
        className={classnames([
          'tfl-header__mobile-search-cancel',
          `tfl-header__mobile-search-cancel--${
            isSearchFocused || searchValue ? 'focused' : 'unfocused'
          }`,
        ])}
      >
        Cancel
      </button>
    </div>
  );
};

export default Search;
